import {
  BasicTableSettings,
  RefreshableTableSettings,
  createPersistedStore,
  refreshableSettings,
  paginationSettings,
} from '@@/datatables/types';

export interface TableSettings
  extends BasicTableSettings,
    RefreshableTableSettings {}

export function createStore(storageKey: string) {
  return createPersistedStore<TableSettings>(
    storageKey,
    { id: 'startedAtUnix', desc: true },
    (set) => ({
      ...refreshableSettings(set, 20),
      ...paginationSettings(set, 5),
    })
  );
}
